import React from "react";
import { AiOutlineClose } from "react-icons/ai";

type CancelEditProps = {
  handleCloseEdit: () => void;
  setCancelEdit: (value: React.SetStateAction<boolean>) => void;
};
const CancelEdit: React.FC<CancelEditProps> = ({
  handleCloseEdit,
  setCancelEdit,
}) => {
  return (
    <div className="fixed picModal inset-0 z-30 flex items-center justify-center backdrop-filter bg-[#FFFFFFC2] overflow-y-hidden">
      <div className="flex flex-col rounded-lg lg:w-[32%] shadow-lg bg-white">
        <div className="flex justify-between h-[10%] items-center border-b border-b-[#D8D3D3] pr-7 py-1">
          <div className="flex items-center flex-1 text-xl font-Poppins font-medium justify-center text-[#000]">
            Unsaved changes
          </div>
          <button
            className="py-2 px-2
            rounded-full text-[#33363F]
            bg-[#ECE6E6] active:bg-bgGrey
            hover:text-gray-600"
          >
            <AiOutlineClose size={20} onClick={() => setCancelEdit(false)} />
          </button>
        </div>
        <div className="flex flex-col py-2 px-3">
          Changes you've made will not be saved.
          <div className="mt-10 flex w-full flex-row-reverse gap-3">
            <button
              onClick={handleCloseEdit}
              className="flex bg-midGreen text-white justify-center items-center text-lg w-[30%] rounded-md shadow py-2 font-semibold"
            >
              Discard
            </button>
            <button
              onClick={() => setCancelEdit(false)}
              className="flex text-midGreen justify-center items-center w-[30%] rounded-md py-2 hover:bg-gray-200 text-lg"
            >
              Continue editing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelEdit;
